import i from "./isDetailedProductVariantOutOfStocks.mjs";
import "./getDetailedProductVariantStock.mjs";
import "./isDetailedProductOutletStockOutOfStock.mjs";
function k(f, e) {
  var t;
  return ((t = e || []) == null ? void 0 : t.length) > 0 && (e == null ? void 0 : e.every(
    (o) => i(o, f)
  ));
}
export {
  k as default
};
